import { render, staticRenderFns } from "./Totalizer.vue?vue&type=template&id=7f21fcaf&scoped=true"
import script from "./Totalizer.vue?vue&type=script&lang=js"
export * from "./Totalizer.vue?vue&type=script&lang=js"
import style0 from "./Totalizer.vue?vue&type=style&index=0&id=7f21fcaf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f21fcaf",
  null
  
)

export default component.exports